import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';
import '../../timeSheet.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { faCircleCheck, faCircleXmark } from '@fortawesome/free-regular-svg-icons';
import { TextField } from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Select from 'react-select';
// import dayjs from "dayjs";
function ManageProjectTimesheet() {
    const navigate = useNavigate();
    const [selectedDate, setSelectedDate] = useState(null);
    const [weekRange, setWeekRange] = useState("");

    const handleDateChange = (date) => {
        setSelectedDate(date);

        if (date) {
        //   const day = date.day(); // 0 (Sunday) to 6 (Saturday)
        const sunday = date.startOf("week"); // Sunday
        const saturday = sunday.add(6, "day"); // Saturday

        const formattedRange = `${sunday.format("DD/MM/YYYY")} to ${saturday.format("DD/MM/YYYY")}`;
        setWeekRange(formattedRange);
        } else {
        setWeekRange("");
        }
    };

  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{xs:12}} container className="main_jobseeker">
                <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                    <h3>Timesheet Management</h3>
                    <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Timesheet Management</span>
                </Grid>
                <Grid size={{ xs: 12 }} container justifyContent="flex-end" alignItems="center" className="my-4">
                    <Grid size={{xs: 12 }} container className="gap-3 d-none regiter_inputs i94validateinput">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                        className="date_pickermux date_selectsheet"
                        value={selectedDate}
                        onChange={handleDateChange}
                        renderInput={(params) => <TextField {...params} />}
                        />
                    </LocalizationProvider>
                    {weekRange && <input style={{width:"max-content"}} value={weekRange} disabled />}
                    </Grid>
                    <Grid size={{xs:12}} container justifyContent="space-between">
                        <Grid size={{sm:12,xs:12}} container flexDirection="column" className="i94validateinput employee_select" alignItems="flex-start">
                            <span className='mt-0'>Select Project</span>
                            <Select
                                styles={{minWidth:"300px"}}
                                className="basic-single select_withsearch"
                                classNamePrefix="select"
                                // value={selectedUserId}
                                defaultValue={null}
                                // name="Q00010"
                                // options={userId.map((users) => ({
                                //     label: users.full_name,
                                //     value: users.id,
                                // }))}
                                // onChange={handleUserIdChange}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={{xs:12}} container className="mt-4 timesheet_table timesheet_subadmin">
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th className='text-center'><input type='checkbox'/></th>
                                <th>Projects</th>
                                <th>Status</th>
                                <th>Total Employee</th>
                                <th>Total Work Hours</th>
                            </tr>
                        </thead>
                        <tbody className='tablerow_oddone'>
                            <tr>
                                <td className='text-center'><input type='checkbox'/></td>
                                <td className='text-start bluecursor_timesheet'>
                                    <span onClick={()=>navigate("/timesheet/project-review")}>March 1-7 2024</span>
                                </td>
                                <td>
                                    <span className='rejected_timesheet'><FontAwesomeIcon icon={faCircleXmark} /> Rejected</span>
                                </td>
                                <td className='text-start'>40.00</td>
                                <td className='text-start'>40.00</td>
                            </tr>
                            <tr>
                            <td className='text-center'><input type='checkbox'/></td>
                            <td className='text-start bluecursor_timesheet'>
                                <span onClick={()=>navigate("/timesheet/project-review")}>March 1-7 2024</span>
                            </td>
                            <td>
                                <span className='submitted_timesheet'><FontAwesomeIcon icon={faCircleCheck} /> Submitted</span>
                            </td>
                            <td className='text-start'>40.00</td>
                            <td className='text-start'>40.00</td>
                            </tr>
                            <tr>
                            <td className='text-center'><input type='checkbox'/></td>
                            <td className='text-start bluecursor_timesheet'>
                                <span onClick={()=>navigate("/timesheet/project-review")}>March 1-7 2024</span>
                            </td>
                            <td>
                                <span className='approved_timesheet'><FontAwesomeIcon icon={faCircleCheck} /> Approved</span>
                            </td>
                            <td className='text-start'>40.00</td>
                            <td className='text-start'>40.00</td>
                            </tr>
                        </tbody>
                    </table>
                </Grid>
            </Grid>
        </div>
    </div>
  );
}

export default ManageProjectTimesheet;